module.exports = __webpack_public_path__ + "img/pointIconAzul.c423b1ff.png";